// What the phone layout has open over the board: a sheet from its bar, or one widget full screen.

import { create } from "zustand";
import type { ID } from "../../shared/types";

export type PhoneSheet = "boards" | "more" | null;

export const usePhone = create<{ sheet: PhoneSheet; full: ID | null }>(() => ({ sheet: null, full: null }));

export const openSheet = (sheet: PhoneSheet) => usePhone.setState({ sheet });
export const closeSheet = () => usePhone.setState({ sheet: null });
export const openFull = (id: ID) => usePhone.setState({ full: id, sheet: null });
export const closeFull = () => usePhone.setState({ full: null });
